import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const outcomesConfig: PageConfig[] = [
  {
    name: "outcomes",
    title: "Outcomes and Impact",
    questions: [
      {
        type: "comment",
        name: "outcomes",
        title: `
          Outline how you achieved the goals and outcomes of your initiative?
          What impact did your initiative have on Rangitāne whānau?
        `,
        placeHolder: "Ngā hua",
        isRequired: true,
      },
    ],
  },
];
